export class RecentProjectModel {
    constructor(private projectId: string, private userId: string, private isDefaultProject: number,
        private projectType: number, private id?: string, private lastAccessDate?: number,
        private clientId?: string, private clientName?: string){};
}
